import { createContext, useContext, type ReactNode } from 'react';
import { useCentralizedAuth } from '@/hooks/use-centralized-auth';

type AuthContextType = ReturnType<typeof useCentralizedAuth>;

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useCentralizedAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
